import { NavList } from '@eventbrite/eds-nav-list';
import { ANCHOR_LINK } from '@eventbrite/eds-nav-list-item';
import React from 'react';
import { TimeframesMap } from '../types';
import { timeframesMap } from '../utils';

const TimeframeNavList = ({
    activeTimeframe,
    location,
    onClick,
}: {
    activeTimeframe: string;
    location: string;
    onClick: Function;
}) => {
    const items = Object.keys(timeframesMap).map((key: string) => ({
        type: ANCHOR_LINK,
        content: timeframesMap[key as keyof TimeframesMap],
        active: activeTimeframe === key,
        onClick: () => onClick(key, location),
    }));

    return (
        <div id="timeframe-nav-list">
            <NavList items={items} displayInline={true} />
        </div>
    );
};

export default TimeframeNavList;
